<template>
  <v-btn
    class="ma-2"
    flat
    :loading="loading"
    @click="download()"
  >
    <v-icon left>
      mdi-download-box-outline
    </v-icon> {{ label }}
  </v-btn>
</template>

<script>
import notificationMixin from 'Support/mixins/notification-mixin';
import BoletoRequest from 'Domain/boleto/BoletoRequest';

export default {
  name: 'BtnDownloadBoleto',
  mixins: [notificationMixin],
  props: {
    label: {
      type: String,
      default: 'Download',
    },
    tipoOperacao: {
      type: String,
      required: true,
    },
    confirmTitle: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    successText: {
      type: String,
      default: '',
    },
    faultError: {
      type: String,
      default: '',
    },
    faultFileName: {
      type: String,
      default: '',
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    requestClass: BoletoRequest,
  }),
  computed: {
    confirmFields() {
      return {
        title: this.confirmTitle,
        text: this.confirmText,
      };
    },
    successFields() {
      return {
        title: 'Sucesso',
        text: this.successText,
      };
    },
    getId() {
      return this.row.id;
    },
  },
  methods: {
    download() {
      this.showConfirmDialog(
        this.confirmFields,
      ).then(
        (res = {}) => {
          if (res.value) {
            this.makeDownload();
          }
        },
      );
    },
    async makeDownload() {
      try {
        this.loading = !this.loading;
        const res = await (this.tipoOperacao !== 'EMPRESTIMO'
          ? this.requestClass.download(
            this.getId,
            this.tipoOperacao,
          ) : this.requestClass.downloadV2(this.getId));
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const fileName = this.prepareFileName(res);
        const link = document.createElement('a');

        link.download = fileName;
        link.href = URL.createObjectURL(blob, { type: 'text/plain' });
        link.click();

        this.showSuccessToast(
          this.successFields,
        );
      } catch (err) {
        const error = err || {};
        this.showErrorToast({
          title: 'Erro',
          text: error.response.statusText || error.message || this.faultError,
        });
      } finally {
        this.loading = !this.loading;
      }
    },
    prepareFileName(response = {}) {
      const faultName = this.faultFileName;

      if (faultName) {
        return String(faultName).replace(':id', this.getId);
      }

      if (!response.headers) return faultName;

      const header = response.headers['content-disposition'];
      if (this.isString(header)) {
        return String(String(header).split('filename=')[1].split(';')[0]).replace('"', '').replace('"', '');
      }

      const url = response.request.responseURL;
      if (this.isString(url)) {
        const lastBarIndex = String(url).lastIndexOf('/');
        return String(url).split('').slice(lastBarIndex)
          .join('');
      }

      return faultName;
    },
    isString(item) {
      return item && typeof item === 'string';
    },
  },
};
</script>
